import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';

export const MyPresetUikit = definePreset(Lara, {
  semantic: {
    colorScheme: {
      dark: {
        primary: {
          500: 'var(--primary-regular-default)',
          600: 'var(--primary-regular-hover)',
          700: 'var(--primary-regular-active)',
        },
      },
      light: {
        primary: {
          500: 'var(--primary-regular-default)',
          600: 'var(--primary-regular-hover)',
          700: 'var(--primary-regular-active)',
        },
      },
    },
  },

  components: {
    // - - - button - - -
    button: {
      label: {
        fontWeight: '400',
      },
      icon: { only: { width: '38px' } },
      colorScheme: {
        dark: {
          root: {
            primary: {
              background: 'var(--primary-regular-default)',
              borderColor: 'var(--primary-regular-default)',
              color: '#FFFFFF',
              hoverBackground: 'var(--primary-regular-hover)',
              hoverBorderColor: 'var(--primary-regular-hover)',
              hoverColor: '#FFFFFF',
              activeBackground: 'var(--primary-regular-active)',
              activeBorderColor: 'var(--primary-regular-active)',
              activeColor: '#FFFFFF',
              focusRing: {
                shadow: '0 0 0 0.2rem var(--primary-subtle-hover)',
              },
            },
            secondary: {
              background: 'var(--secondary-regular-default)',
              borderColor: 'var(--secondary-regular-default)',
              color: 'var(--secondary-subtle-inverse)',
              hoverBackground: 'var(--secondary-regular-hover)',
              hoverBorderColor: 'var(--secondary-regular-hover)',
              hoverColor: 'var(--secondary-subtle-inverse)',
              activeBackground: 'var(--secondary-regular-active)',
              activeBorderColor: 'var(--secondary-regular-active)',
              activeColor: 'var(--secondary-subtle-inverse)',
              focusRing: {
                shadow: '0 0 0 0.2rem var(--secondary-subtle-hover)',
              },
            },
            info: {
              background: 'var(--info-regular-default)',
              borderColor: 'var(--info-regular-default)',
              color: 'var(--secondary-subtle-inverse)',
              hoverBackground: 'var(--info-regular-hover)',
              hoverBorderColor: 'var(--info-regular-hover)',
              hoverColor: 'var(--secondary-subtle-inverse)',
              activeBackground: 'var(--info-regular-active)',
              activeBorderColor: 'var(--info-regular-active)',
              activeColor: 'var(--secondary-subtle-inverse)',
              focusRing: {
                shadow: '0 0 0 0.2rem var(--secondary-subtle-hover)',
              },
            },
          },
          outlined: {
            primary: {
              hoverBackground: 'var(--primary-regular-hover)',
              activeBackground: 'var(--primary-regular-active)',
              borderColor: 'var(--primary-regular-default)',
              color: 'var(--primary-regular-default)',
            },
            secondary: {
              hoverBackground: 'var(--secondary-regular-hover)',
              activeBackground: 'var(--secondary-regular-active)',
              borderColor: 'var(--secondary-regular-default)',
              color: 'var(--secondary-subtle-inverse)',
            },
            danger: {
              hoverBackground: 'var(--secondary-regular-hover)',
              activeBackground: 'var(--secondary-regular-active)',
              color: 'var(--danger-subtle-inverse)',
              borderColor: 'var(--secondary-subtle-hover)',
            },
            info: {
              hoverBackground: 'var(--info-regular-hover)',
              activeBackground: 'var(--info-regular-active)',
              borderColor: 'var(--info-regular-default)',
              color: 'var(--secondary-subtle-inverse)',
            },
          },
          text: {
            primary: {
              color: 'var(--primary-subtle-inverse)',
              hoverBackground: 'var(--primary-subtle-default)',
              activeBackground: 'var(--primary-subtle-hover)',
              focusRing: {
                shadow: '0 0 0 0.2rem var(--primary-subtle-hover)',
              },
            },
            secondary: {
              color: 'var(--secondary-subtle-inverse)',
              hoverBackground: 'var(--secondary-subtle-default)',
              activeBackground: 'var(--secondary-subtle-hover)',
              focusRing: {
                shadow: '0 0 0 0.2rem var(--secondary-subtle-hover)',
              },
            },
            info: {
              color: 'var(--secondary-subtle-inverse)',
              hoverBackground: 'var(--info-regular-hover)',
              activeBackground: 'var(--info-regular-active)',
              focusRing: {
                shadow: '0 0 0 0.2rem var(--secondary-subtle-hover)',
              },
            },
          },
          link: {
            color: 'var(--primary-regular-default)',
            hover: { color: 'var(--primary-regular-default)' },
            active: { color: 'var(--primary-regular-default)' },
            focusRing: {
              shadow: '0 0 0 0.2rem var(--primary-subtle-hover)',
            },
          },
        },
        light: {
          root: {
            primary: {
              background: 'var(--primary-regular-default)',
              borderColor: 'var(--primary-regular-default)',
              color: '#FFFFFF',
              hoverBackground: 'var(--primary-regular-hover)',
              hoverColor: '#FFFFFF',
              hoverBorderColor: 'var(--primary-regular-hover)',
              activeBackground: 'var(--primary-regular-active)',
              activeBorderColor: 'var(--primary-regular-active)',
              activeColor: '#FFFFFF',
              focusRing: {
                shadow: '0 0 0 0.2rem var(--primary-subtle-hover)',
              },
            },
            secondary: {
              background: 'var(--secondary-regular-default)',
              borderColor: 'var(--secondary-regular-default)',
              color: 'var(--secondary-subtle-inverse)',
              hoverBackground: 'var(--secondary-regular-hover)',
              hoverBorderColor: 'var(--secondary-regular-hover)',
              hoverColor: 'var(--secondary-subtle-inverse)',
              activeBackground: 'var(--secondary-regular-active)',
              activeBorderColor: 'var(--secondary-regular-active)',
              activeColor: 'var(--secondary-subtle-inverse)',
              focusRing: {
                shadow: '0 0 0 0.2rem var(--secondary-subtle-hover)',
              },
            },
            info: {
              background: 'var(--info-regular-default)',
              borderColor: 'var(--info-regular-default)',
              color: 'var(--secondary-subtle-inverse)',
              hoverBackground: 'var(--info-regular-hover)',
              hoverBorderColor: 'var(--info-regular-hover)',
              hoverColor: 'var(--secondary-subtle-inverse)',
              activeBackground: 'var(--info-regular-active)',
              activeBorderColor: 'var(--info-regular-active)',
              activeColor: 'var(--secondary-subtle-inverse)',
              focusRing: {
                shadow: '0 0 0 0.2rem var(--secondary-subtle-hover)',
              },
            },
          },
          text: {
            primary: {
              color: 'var(--primary-subtle-inverse)',
              hoverBackground: 'var(--primary-subtle-default)',
              activeBackground: 'var(--primary-subtle-hover)',
              focusRing: {
                shadow: '0 0 0 0.2rem var(--primary-subtle-hover)',
              },
            },
            secondary: {
              color: 'var(--secondary-subtle-inverse)',
              hoverBackground: 'var(--primary-subtle-default)',
              activeBackground: 'var(--primary-subtle-hover)',
              focusRing: {
                shadow: '0 0 0 0.2rem var(--secondary-subtle-hover)',
              },
            },
            info: {
              color: 'var(--secondary-subtle-inverse)',
              hoverBackground: 'var(--info-regular-hover)',
              activeBackground: 'var(--info-regular-active)',
              focusRing: {
                shadow: '0 0 0 0.2rem var(--secondary-subtle-hover)',
              },
            },
          },
          link: {
            color: 'var(--primary-regular-default)',
            hover: { color: 'var(--primary-regular-default)' },
            active: { color: 'var(--primary-regular-default)' },
            focusRing: {
              shadow: '0 0 0 0.2rem var(--primary-subtle-hover)',
            },
          },
        },
        outlined: {
          primary: {
            hoverBackground: 'var(--primary-subtle-hover)',
            activeBackground: 'var(--primary-subtle-active)',
            borderColor: 'var(--primary-regular-default)',
            color: 'var(--primary-regular-default)',
          },
          secondary: {
            hoverBackground: 'var(--secondary-regular-hover)',
            activeBackground: 'var(--secondary-regular-active)',
            borderColor: 'var(--secondary-regular-default)',
            color: 'var(--secondary-subtle-inverse)',
          },
          danger: {
            hoverBackground: 'var(--secondary-regular-hover)',
            activeBackground: 'var(--secondary-regular-active)',
            color: 'var(--danger-subtle-inverse)',
            borderColor: 'var(--secondary-subtle-hover)',
          },
          info: {
            background: 'var(--contrast-inverse)',
            hoverBackground: 'var(--primary-subtle-default)',
            activeBackground: 'var(--primary-subtle-hover)',
            borderColor: 'var(--info-regular-active)',
            color: 'var(--secondary-subtle-inverse)',
          },
        },
        text: {
          primary: {
            color: 'var(--primary-subtle-inverse)',
            hoverBackground: 'var(--primary-subtle-default)',
            activeBackground: 'var(--primary-subtle-hover)',
            focusRing: {
              shadow: '0 0 0 0.2rem var(--primary-subtle-hover)',
            },
          },
          secondary: {
            color: 'var(--secondary-subtle-inverse)',
            hoverBackground: 'var(--secondary-subtle-default)',
            activeBackground: 'var(--secondary-subtle-hover)',
            focusRing: {
              shadow: '0 0 0 0.2rem var(--secondary-subtle-hover)',
            },
          },
        },
        link: {
          color: 'var(--primary-regular-default)',
          hover: { color: 'var(--primary-regular-default)' },
          active: { color: 'var(--primary-regular-default)' },
          focusRing: {
            shadow: '0 0 0 0.2rem var(--primary-subtle-hover)',
          },
        },
      },
    },

    // - - - input - - -
    inputtext: {
      colorScheme: {
        dark: {
          border: { radius: '28px', color: 'var(--secondary-regular-default)' },
          background: 'var(--contrast-inverse)',
          placeholder: { color: 'var(--secondary-subtle-active)' },
          color: 'var(--text-default)',
          disabled: {
            background: 'var(--contrast-inverse)',
            color: 'var(--secondary-subtle-active)',
          },
          focus: {
            ring: { shadow: '0 0 0 0.2rem var(--secondary-subtle-hover)' },
            border: { color: 'var(--secondary-subtle-active)' },
          },
          hover: { border: { color: 'var(--secondary-subtle-active)' } },
          invalid: {
            border: {
              color: 'var(--danger-regular-default)',
            },
            placeholder: {
              color: 'var(--danger-regular-default)',
            },
          },
        },
        light: {
          border: { radius: '28px', color: 'var(--secondary-regular-default)' },
          background: 'var(--contrast-inverse)',
          placeholder: { color: 'var(--secondary-subtle-active)' },
          color: 'var(--text-default)',
          disabled: {
            background: 'var(--contrast-inverse)',
            color: 'var(--secondary-subtle-active)',
          },
          focus: {
            ring: { shadow: '0 0 0 0.2rem var(--secondary-subtle-hover)' },
            border: { color: 'var(--secondary-subtle-active)' },
          },
          hover: { border: { color: 'var(--secondary-subtle-active)' } },
          invalid: {
            border: {
              color: 'var(--danger-regular-default)',
            },
            placeholder: {
              color: 'var(--danger-regular-default)',
            },
          },
        },
      },
    },

    // - - - toast - - -
    toast: {
      colorScheme: {
        dark: {
          blur: '32px',
        },
        light: {
          root: {
            blur: '1.5px',
          },
        },
      },
    },

    // - - - paginator - - -
    paginator: {
      padding: '0px',

      colorScheme: {
        dark: {
          background: 'transparent',
          nav: { button: { selected: { background: 'var(--primary-regular-default)', color: 'var(--primary-regular-inverse)' } } },
        },
        light: {
          background: 'transparent',
          nav: { button: { selected: { background: 'var(--primary-regular-default)', color: 'var(--primary-regular-inverse)' } } },
        },
      },
    },

    // - - - tooltip - - -
    tooltip: {
      colorScheme: {
        dark: {
          background: 'var(--contrast-default)',
          color: 'var(--text-inverse)',
          maxWidth: '20rem',
        },
        light: {
          root: {
            background: 'var(--contrast-default)',
            color: 'var(--text-inverse)',
            maxWidth: '20rem',
          },
        },
      },
    },

    // - - - select - - -
    select: {
      colorScheme: {
        dark: {
          background: 'var(--contrast-inverse)',
          placeholder: { color: 'var(--secondary-subtle-active)' },
          color: 'var(--text-default)',
          border: { radius: '28px', color: 'var(--secondary-subtle-active)' },
          focus: {
            ring: { shadow: '0 0 0 0.2rem var(--secondary-subtle-hover)' },
            border: { color: 'var(--secondary-subtle-active)' },
          },
          hover: { border: { color: 'var(--secondary-subtle-active)' } },
          disabled: {
            background: 'var(--secondary-subtle-default)',
            color: 'var(--text-label)',
            border: { color: 'var(--secondary-regular-default)' },
          },
          overlay: {
            background: 'var(--contrast-inverse)',
            border: { color: 'var(--secondary-subtle-hover)' },
            color: 'var(--text-default)',
          },
          option: {
            color: 'var(--text-default)',
            selected: {
              color: 'var(--primary-subtle-inverse)',
              background: 'var(--primary-subtle-default)',
              focus: { 
                color: 'var(--primary-subtle-inverse)', 
                background: 'var(--primary-subtle-default)'
              },
            },
            focus: { 
              color: 'var(--text-default)', 
              background: 'var(--secondary-subtle-hover)'
            },
          },
          invalid: {
            border: {
              color: 'var(--danger-regular-default)',
            },
            placeholder: {
              color: 'var(--danger-regular-default)',
            },
          },
        },
        light: {
          background: 'var(--contrast-inverse)',
          placeholder: { color: 'var(--secondary-subtle-active)' },
          color: 'var(--text-default)',
          border: { radius: '28px', color: 'var(--secondary-subtle-active)' },
          focus: {
            ring: { shadow: '0 0 0 0.2rem var(--secondary-subtle-hover)' },
            border: { color: 'var(--secondary-subtle-active)' },
          },
          hover: { border: { color: 'var(--secondary-subtle-active)' } },
          disabled: {
            background: 'var(--secondary-subtle-default)',
            color: 'var(--text-label)',
            border: { color: 'var(--secondary-regular-default)' },
          },
          overlay: {
            background: 'var(--contrast-inverse)',
            border: { color: 'var(--secondary-subtle-hover)' },
          },
          option: {
            color: 'var(--text-default)',
            selected: {
              color: 'var(--primary-subtle-inverse)',
              background: 'var(--primary-subtle-default)',
              focus: { 
                color: 'var(--primary-subtle-inverse)',
                background: 'var(--primary-subtle-default)' 
              },
            },
            focus: { 
              color: 'var(--text-default)', 
              background: 'var(--secondary-subtle-hover)'
            },
          },
          invalid: {
            border: {
              color: 'var(--danger-regular-default)',
            },
            placeholder: {
              color: 'var(--danger-regular-default)',
            },
          },
        },
      },
    },

    // - - - autocomplete - - -
    autocomplete: {
      colorScheme: {
        dark: {
          background: 'var(--contrast-inverse)',
          placeholder: { color: 'var(--secondary-subtle-active)' },
          color: 'var(--text-default)',
          border: { radius: '28px', color: 'var(--secondary-subtle-active)' },
          focus: {
            ring: { shadow: '0 0 0 0.2rem var(--secondary-subtle-hover)' },
            border: { color: 'var(--secondary-subtle-active)' },
          },
          hover: { border: { color: 'var(--secondary-subtle-active)' } },
          disabled: {
            background: 'var(--contrast-inverse)',
            color: 'var(--secondary-subtle-active)',
          },
          overlay: {
            background: 'var(--contrast-inverse)',
            border: { color: 'var(--secondary-subtle-hover)' },
            color: 'var(--text-default)',
          },
          option: {
            color: 'var(--text-default)',
            selected: {
              color: 'var(--primary-subtle-inverse)',
              background: 'var(--primary-subtle-default)',
              focus: { color: 'var(--primary-subtle-inverse)', background: 'var(--primary-subtle-default)' },
            },
          },
          invalid: {
            border: {
              color: 'var(--danger-regular-default)',
            },
            placeholder: {
              color: 'var(--danger-regular-default)',
            },
          },
        },
        light: {
          background: 'var(--contrast-inverse)',
          placeholder: { color: 'var(--secondary-subtle-active)' },
          color: 'var(--text-default)',
          border: { radius: '28px', color: 'var(--secondary-subtle-active)' },
          focus: {
            ring: { shadow: '0 0 0 0.2rem var(--secondary-subtle-hover)' },
            border: { color: 'var(--secondary-subtle-active)' },
          },
          hover: { border: { color: 'var(--secondary-subtle-active)' } },
          disabled: {
            background: 'var(--contrast-inverse)',
            color: 'var(--secondary-subtle-active)',
          },
          overlay: {
            background: 'var(--contrast-inverse)',
            border: { color: 'var(--secondary-subtle-hover)' },
          },
          option: {
            color: 'var(--text-default)',
            selected: {
              color: 'var(--primary-subtle-inverse)',
              background: 'var(--primary-subtle-default)',
              focus: { color: 'var(--primary-subtle-inverse)', background: 'var(--primary-subtle-default)' },
            },
          },
          invalid: {
            border: {
              color: 'var(--danger-regular-default)',
            },
            placeholder: {
              color: 'var(--danger-regular-default)',
            },
          },
        },
      },
    },

    // - - - multiselect - - -
    multiselect: {
      colorScheme: {
        dark: {
          label: {
            color: 'var(--text-default)',
            fontSize: '12px',
            lineHeight: '16px',
            fontWeight: '500',
          },
          list: {
            header: {
              padding: '8px 8px 0px 20px',
            },
          },
          background: 'var(--contrast-inverse)',
          placeholder: { color: 'var(--secondary-subtle-active)' },
          color: 'var(--text-default)',
          border: { radius: '28px', color: 'var(--secondary-subtle-active)' },
          focus: {
            ring: { shadow: '0 0 0 0.2rem var(--secondary-subtle-hover)' },
            border: { color: 'var(--secondary-subtle-active)' },
          },
          hover: { border: { color: 'var(--secondary-subtle-active)' } },
          disabled: {
            background: 'var(--secondary-subtle-default)',
            color: 'var(--text-label)',
            border: { color: 'var(--secondary-regular-default)' },
          },
          overlay: {
            background: 'var(--contrast-inverse)',
            border: { color: 'var(--secondary-subtle-hover)' },
            color: 'var(--text-default)',
          },
          option: {
            selectedBackground: 'var(--primary-subtle-default)',
            color: 'var(--text-default)',
            selected: {
              color: 'var(--primary-subtle-inverse)',
              background: 'var(--primary-subtle-default)',
              focus: { color: 'var(--primary-subtle-inverse)', background: 'var(--primary-subtle-default)' },
            },
            focus: { 
              color: 'var(--text-default)', 
              background: 'var(--secondary-subtle-hover)'
            },
          },
          invalid: {
            border: {
              color: 'var(--danger-regular-default)',
            },
            placeholder: {
              color: 'var(--danger-regular-default)',
            },
          },
        },
        light: {
          list: {
            header: {
              padding: '8px 8px 0px 20px',
            },
          },
          background: 'var(--contrast-inverse)',
          placeholder: { color: 'var(--secondary-subtle-active)' },
          color: 'var(--text-default)',
          border: { radius: '28px', color: 'var(--secondary-subtle-active)' },
          focus: {
            ring: { shadow: '0 0 0 0.2rem var(--secondary-subtle-hover)' },
            border: { color: 'var(--secondary-subtle-active)' },
          },
          hover: { border: { color: 'var(--secondary-subtle-active)' } },
          disabled: {
            background: 'var(--secondary-subtle-default)',
            color: 'var(--text-label)',
            border: { color: 'var(--secondary-regular-default)' },
          },
          overlay: {
            background: 'var(--contrast-inverse)',
            border: { color: 'var(--secondary-subtle-hover)' },
            color: 'var(--text-default)',
          },
          option: {
            selectedBackground: 'var(--primary-subtle-default)',
            color: 'var(--text-default)',
            selected: {
              color: 'var(--primary-subtle-inverse)',
              background: 'var(--primary-subtle-default)',
              focus: { color: 'var(--primary-subtle-inverse)', background: 'var(--primary-subtle-default)' },
            },
            focus: { 
              color: 'var(--text-default)', 
              background: 'var(--secondary-subtle-hover)'
            },
          },
          invalid: {
            border: {
              color: 'var(--danger-regular-default)',
            },
            placeholder: {
              color: 'var(--danger-regular-default)',
            },
          },
        },
      },
    },

    // - - - menu - - -
    menu: {
      colorScheme: {
        dark: {
          background: 'var(--contrast-inverse)',
          color: 'var(--text-default)',
          border: { color: 'var(--secondary-subtle-hover)', radius: '16px' },
          list: { padding: '8px' },
          item: {
            color: 'var(--text-default)',
            focus: { color: 'var(--text-default)', background: 'var(--secondary-subtle-default)' },
            border: { radius: '4px' },
            icon: { focus: { color: 'var(--secondary-subtle-inverse)' }, color: 'var(--secondary-subtle-inverse)' },
          },
        },
        light: {
          background: 'var(--contrast-inverse)',
          color: 'var(--text-default)',
          border: { color: 'var(--secondary-subtle-hover)', radius: '16px' },
          list: { padding: '8px' },
          item: {
            color: 'var(--text-default)',
            focus: { color: 'var(--text-default)', background: 'var(--secondary-subtle-default)' },
            border: { radius: '4px' },
            icon: { focus: { color: 'var(--secondary-subtle-inverse)' }, color: 'var(--secondary-subtle-inverse)' },
          },
        },
      },
    },

    // - - - dialog - - -
    dialog: {
      colorScheme: {
        dark: {
          background: 'var(--contrast-inverse)',
          color: 'var(--text-default)',
        },
        light: {
          background: 'var(--contrast-inverse)',
          color: 'var(--text-default)',
        },
      },
    },

    // - - - tabs - - -
    tabs: {
      colorScheme: {
        dark: {
          tablist: {
            border: { color: 'var(--secondary-subtle-active)', width: '0 0 2px 0' },
            background: 'transparent',
          },
          navButton: {
            focusRing: {
              shadow: 'transparent',
            },
          },
          tabpanel: {
            background: 'transparent',
            focusRing: {
              shadow: 'transparent',
            },
          },
          tab: {
            padding: '8px 12px',
            color: 'var(--text-label)',
            fontWeight: '450',
            background: 'transparent',
            border: { color: 'var(--secondary-subtle-active)', width: '0 0 2px 0' },
            hover: { color: 'var(--primary-regular-default)', background: 'transparent' },
            active: { background: 'transparent', color: 'var(--primary-subtle-inverse)' },
            focusRing: {
              shadow: 'transparent',
            },
          },
        },
        light: {
          tablist: {
            border: { color: 'var(--primary-subtle-default)', width: '0 0 2px 0' },
            background: 'transparent',
          },
          navButton: {
            focusRing: {
              shadow: 'transparent',
            },
          },
          tabpanel: {
            background: 'transparent',
            focusRing: {
              shadow: 'transparent',
            },
          },
          tab: {
            padding: '8px 12px',
            color: 'var(--text-label)',
            fontWeight: '450',
            background: 'transparent',
            border: { color: 'var(--primary-subtle-default)', width: '0 0 2px 0' },
            hover: { color: 'var(--primary-regular-default)', background: 'transparent' },
            active: { background: 'transparent', color: 'var(--primary-subtle-inverse)' },
            focusRing: {
              shadow: 'transparent',
            },
          },
        },
      },
    },

    // - - - checkbox - - -
    checkbox: {
      colorScheme: {
        dark: {
          background: 'var(--contrast-inverse)',
          border: { color: 'var(--contrast-hover)' },
          focus: {
            ring: { shadow: '0 0 0 0.2rem var(--secondary-subtle-hover)' },
            border: { color: 'var(--secondary-subtle-active)' },
          },
        },
        light: {
          background: 'var(--contrast-inverse)',
          border: { color: 'var(--contrast-hover)' },
          focus: {
            ring: { shadow: '0 0 0 0.2rem var(--secondary-subtle-hover)' },
            border: { color: 'var(--secondary-subtle-active)' },
          },
        },
      },
    },

    // - - - datatable - - -
    datatable: {
      colorScheme: {
        dark: {
          headerCell: {
            background: 'var(--contrast-inverse)',
            color: 'var(--text-default)',
          },
          column: { title: { font: { weight: '500', color: 'var(--text-default)' } } },
          header: {
            cell: {
              background: 'var(--contrast-inverse)',
              border: { color: 'var(--secondary-subtle-hover)' },
              color: 'var(--text-default)',
            },
          },
          body: {
            cell: { background: 'var(--contrast-inverse)', border: { color: 'var(--secondary-subtle-hover)' } },
          },
          row: {
            background: 'var(--contrast-inverse)',
            color: 'var(--text-default)',
          },
        },
        light: {
          headerCell: {
            background: 'var(--contrast-inverse)',
            color: 'var(--text-default)',
          },
          column: { title: { font: { weight: '500', color: 'var(--text-default)' } } },
          header: {
            cell: {
              background: 'var(--contrast-inverse)',
              border: { color: 'var(--secondary-subtle-hover)' },
              color: 'var(--text-default)',
            },
          },
          body: {
            cell: { background: 'var(--contrast-inverse)', border: { color: 'var(--secondary-subtle-hover)' } },
          },
          row: {
            color: 'var(--text-default)',
            background: 'var(--contrast-inverse)',
          },
        },
      },
    },

    // - - - tag - - -
    tag: {
      font: {
        size: '12px',
      },
      fontWeight: '500',
      colorScheme: {
        dark: {
          primary: {
            background: 'var(--primary-regular-default)',
            color: 'var(--primary-regular-inverse)',
          },
          secondary: {
            background: 'var(--secondary-subtle-hover)',
            color: 'var(--contrast-default)',
          },
          success: {
            background: 'var(--success-regular-default)',
            color: 'var(--success-regular-inverse)',
          },
          info: {
            background: 'var(--info-regular-default)',
            color: 'var(--secondary-subtle-inverse)',
          },
          warn: {
            background: 'var(--warning-regular-default)',
            color: 'var(--warning-regular-inverse)',
          },
          danger: {
            background: 'var(--danger-regular-default)',
            color: 'var(--danger-regular-inverse)',
          },
          contrast: {
            background: 'var(--contrast-default)',
            color: 'var(--contrast-inverse)',
          },
        },
        light: {
          primary: {
            background: 'var(--primary-regular-default)',
            color: 'var(--primary-regular-inverse)',
          },
          secondary: {
            background: 'var(--secondary-subtle-hover)',
            color: 'var(--contrast-default)',
          },
          success: {
            background: 'var(--success-regular-default)',
            color: 'var(--success-regular-inverse)',
          },
          info: {
            background: 'var(--info-regular-default)',
            color: 'var(--secondary-subtle-inverse)',
          },
          warn: {
            background: 'var(--warning-regular-default)',
            color: 'var(--warning-regular-inverse)',
          },
          danger: {
            background: 'var(--danger-regular-default)',
            color: 'var(--danger-regular-inverse)',
          },
          contrast: {
            background: 'var(--contrast-default)',
            color: 'var(--contrast-inverse)',
          },
        },
      },
    },

    // - - - textarea - - -
    textarea: {
      colorScheme: {
        dark: {
          border: { radius: 'var(--p-inputtext-border-radius)', color: 'var(--secondary-regular-default)' },
          color: 'var(--text-default)',
          placeholder: { color: 'var(--secondary-subtle-active)' },
          background: 'var(--contrast-inverse)',
        },
        light: {
          border: { radius: 'var(--p-inputtext-border-radius)', color: 'var(--secondary-regular-default)' },
          color: 'var(--text-default)',
          placeholder: { color: 'var(--secondary-subtle-active)' },
          background: 'var(--contrast-inverse)',
        },
      },
    },

    divider: {
      content: { background: '#605f7a' },
    },

    // - - - datepicker - - -
    datepicker: {
      date: {
        padding: '3px',
      },
      colorScheme: {
        dark: {
          today: { background: 'var(--secondary-subtle-default)' },
          date: {
            color: 'var(--secondary-subtle-inverse)',
            selected: { background: 'var(--primary-regular-default)' },
            range: { selected: { color: 'var(--primary-regular-inverse)', background: 'var(--primary-regular-default)' } },
          },
          panel: {
            background: 'var(--contrast-inverse)',
            border: { color: 'var(--secondary-subtle-hover)' },
            color: 'var(--text-default)',
          },
          week: { day: { color: 'var(--secondary-subtle-hover)', fontWeight: '500' } },
          select: { month: { color: 'var(--secondary-subtle-inverse)' }, year: { color: 'var(--secondary-subtle-inverse)' } },
          header: {
            background: 'var(--contrast-inverse)',
            border: { color: 'var(--secondary-subtle-hover)' },
          },
          input: { icon: { color: 'var(--secondary-subtle-active)' } },
        },
        light: {
          today: { background: 'var(--secondary-subtle-default)' },
          date: {
            color: 'var(--secondary-subtle-inverse)',
            selected: { background: 'var(--primary-regular-default)' },
            range: { selected: { color: 'var(--primary-regular-inverse)', background: 'var(--primary-regular-default)' } },
          },
          panel: {
            background: 'var(--contrast-inverse)',
            border: { color: 'var(--secondary-subtle-hover)' },
          },
          week: { day: { color: 'var(--secondary-subtle-hover)', fontWeight: '500' } },
          select: { month: { color: 'var(--secondary-subtle-inverse)' }, year: { color: 'var(--secondary-subtle-inverse)' } },
          header: {
            background: 'var(--contrast-inverse)',
            border: { color: 'var(--secondary-subtle-hover)' },
          },
          input: { icon: { color: 'var(--secondary-subtle-active)' } },
        },
      },
    },

    // - - - iconfield - - -
    iconfield: { icon: { color: '#cbd5e1' } },

    // fileupload-header-background

    // - - - fileupload - - -
    fileupload: {
      colorScheme: {
        dark: {
          color: 'var(--text-default)',
          background: 'var(--contrast-inverse)',
          border: { color: 'var(--secondary-subtle-hover)', radius: 'var(--p-inputtext-border-radius)' },
          header: {
            background: 'transparent',
            border: { color: 'var(--secondary-subtle-hover)', width: '0px', radius: '16px 16px 0 0' },
          },
        },
        light: {
          color: 'var(--text-default)',
          background: 'var(--contrast-inverse)',
          border: { color: 'var(--secondary-subtle-hover)', radius: 'var(--p-inputtext-border-radius)' },
          header: {
            background: 'transparent',
            border: { color: 'var(--secondary-subtle-hover)', width: '0px', radius: '16px 16px 0 0' },
          },
        },
      },
    },

    // - - - togglebutton - - -
    togglebutton: {
      sm: {
        padding: '4px',
      },
      fontWeight: '500',
      colorScheme: {
        dark: {
          color: 'var(--secondary-subtle-inverse)',
          background: 'var(--text-inverse)',
          borderColor: 'var(--secondary-subtle-hover)',
          checked: {
            background: 'var(--secondary-regular-default)',
            borderColor: 'var(--secondary-regular-default)',
            color: 'var(--secondary-subtle-inverse)',
          },
          focus: {
            ring: { shadow: '0 0 0 0.2rem var(--secondary-subtle-hover)' },
            border: { color: 'var(--secondary-subtle-active)' },
          },
          hover: {
            background: 'transparent',
          },
          disabled: {
            background: 'var(--secondary-subtle-default)',
            color: 'var(--secondary-subtle-hover)',
            borderColor: 'var(--secondary-subtle-default)',
          },
        },
        light: {
          color: 'var(--secondary-subtle-inverse)',
          background: 'var(--text-inverse)',
          borderColor: 'var(--secondary-subtle-hover)',
          checked: {
            background: 'var(--secondary-regular-default)',
            borderColor: 'var(--secondary-regular-default)',
            color: 'var(--secondary-subtle-inverse)',
          },
          focus: {
            ring: { shadow: '0 0 0 0.2rem var(--secondary-subtle-hover)' },
            border: { color: 'var(--secondary-subtle-active)' },
          },
          hover: {
            background: 'transparent',
          },
          disabled: {
            background: 'var(--secondary-subtle-default)',
            color: 'var(--secondary-subtle-hover)',
            borderColor: 'var(--secondary-subtle-default)',
          },
        },
      },
    },

    // - - - selectbutton - - -
    selectbutton: {
      colorScheme: {
        dark: {
          root: {
            borderRadius: '28px',
          },
        },
        light: {
          root: {
            borderRadius: '28px',
          },
        },
      },
    },

    // - - - popover - - -
    popover: {
      colorScheme: {
        dark: {
          border: { color: 'var(--secondary-subtle-hover)' },
          background: 'var(--contrast-inverse)',
        },
        light: {
          border: { color: 'var(--secondary-subtle-hover)' },
          background: 'var(--contrast-inverse)',
        },
      },
    },

    // - - - toggle-switch - - -
    toggleswitch: {
      colorScheme: {
        dark: {
          background: 'var(--secondary-subtle-hover)',
          checked: {
            background: 'var(--primary-regular-default)',
            hover: {
              background: 'var(--primary-regular-hover)',
            },
            active: {
              background: 'var(--primary-regular-active)',
            },
          },
          handle: {
            background: 'var(--contrast-inverse)',
            hoverBackground: 'var(--contrast-inverse)',
            checked: {
              background: 'var(--primary-regular-inverse)',
            },
            checkedHoverBackground: 'var(--primary-regular-inverse)',
            disabledBackground: 'var(--secondary-subtle-active)',
          },
          disabled: {
            background: 'var(--secondary-subtle-hover)',
          },
        },
        light: {
          background: 'var(--secondary-subtle-hover)',
          checked: {
            background: 'var(--primary-regular-default)',
            hover: {
              background: 'var(--primary-regular-hover)',
            },
            active: {
              background: 'var(--primary-regular-active)',
            },
          },
          handle: {
            background: 'var(--contrast-inverse)',
            checked: {
              background: 'var(--primary-regular-inverse)',
            },
            disabledBackground: 'var(--secondary-subtle-active)',
          },
          disabled: {
            background: 'var(--secondary-subtle-hover)',
          },
        },
      },
    },

    // - - - message - - -
    message: {
      root: {
        borderRadius: '8px',
        borderWidth: '1px',
      },
      text: {
        fontWeight: '400',
      },
      colorScheme: {
        dark: {
          success: {
            background: 'var(--success-subtle-default)',
            borderColor: 'var(--success-subtle-active)',
            color: 'var(--success-subtle-inverse)',
          },
          info: {
            background: 'var(--primary-subtle-default)',
            borderColor: 'var(--primary-subtle-active)',
            color: 'var(--primary-subtle-inverse)',
          },
          error: {
            background: 'var(--danger-subtle-default)',
            borderColor: 'var(--danger-subtle-active)',
            color: 'var(--danger-subtle-inverse)',
          },
          warn: {
            background: 'var(--warning-subtle-default)',
            borderColor: 'var(--warning-subtle-active)',
            color: 'var(--warning-subtle-inverse)',
          },
        },
        light: {
          success: {
            background: 'var(--success-subtle-default)',
            borderColor: 'var(--success-subtle-active)',
            color: 'var(--success-subtle-inverse)',
          },
          info: {
            background: 'var(--primary-subtle-default)',
            borderColor: 'var(--primary-subtle-active)',
            color: 'var(--primary-subtle-inverse)',
          },
          error: {
            background: 'var(--danger-subtle-default)',
            borderColor: 'var(--danger-subtle-active)',
            color: 'var(--danger-subtle-inverse)',
          },
          warn: {
            background: 'var(--warning-subtle-default)',
            borderColor: 'var(--warning-subtle-active)',
            color: 'var(--warning-subtle-inverse)',
          },
        },
      },
    },

    // - - - chip - - -
    chip: {
      colorScheme: {
        borderRadius: '32px',
        paddingY: '9.5px',
        dark: {
          color: 'var(--secondary-subtle-inverse)',
          background: 'var(--info-regular-default)',
          removeIcon: {
            color: 'var(--secondary-subtle-inverse)',
          },
          icon: {
            color: 'var(--secondary-subtle-inverse)',
          },
        },
        light: {
          color: 'var(--secondary-subtle-inverse)',
          background: 'var(--info-regular-default)',
          removeIcon: {
            color: 'var(--secondary-subtle-inverse)',
          },
          icon: {
            color: 'var(--secondary-subtle-inverse)',
          },
        },
      },
    },

    // - - - stepper - - -
    stepper: {
      separator: {
        background: 'var(--secondary-subtle-hover)',
        activeBackground: 'var(--secondary-subtle-hover)',
        size: '2px',
      },
      step: {
        padding: '0',
        gap: '8px',
      },
      stepHeader: {
        padding: '0',
        gap: '8px',
      },
      stepTitle: {
        color: 'var(--secondary-subtle-active)',
        activeColor: 'var(--primary-subtle-inverse)',
        fontWeight: '600',
      },
      stepNumber: {
        background: 'var(--secondary-subtle-hover)',
        activeBackground: 'var(--primary-subtle-hover)',
        borderColor: 'var(--secondary-subtle-hover)',
        activeBorderColor: 'var(--primary-subtle-hover)',
        color: 'var(--secondary-subtle-active)',
        activeColor: 'var(--primary-subtle-inverse)',
        size: '28px',
        fontSize: '16px',
        fontWeight: '500',
        borderRadius: '50%',
        shadow: 'none',
      },
    },
    
    // - - - editor - - -
    editor: {
      colorScheme: {
        dark: {
          toolbar: {
            border: { color: 'var(--secondary-subtle-hover)' },
            background: 'var(--contrast-inverse)',
            borderRadius: '16px',
          },
          toolbarItem: {
            color: 'var(--secondary-subtle-active)',
            hoverColor: 'var(--secondary-subtle-hover)',
            activeColor: 'var(--text-default)',
          },
          content: { 
            background: 'var(--contrast-inverse)',
            color: 'var(--text-default)',
            border: { color: 'var(--secondary-subtle-hover)' },
            borderRadius: '16px',
          },
        },
        light: {
          toolbar: {
            border: { color: 'var(--secondary-subtle-hover)' },
            background: 'var(--contrast-inverse)',
            borderRadius: '16px',
          },
          toolbarItem: {
            color: 'var(--secondary-subtle-active)',
            hoverColor: 'var(--secondary-subtle-hover)',
            activeColor: 'var(--text-default)',
          },
          content: {
            background: 'var(--contrast-inverse)',
            color: 'var(--text-default)',
            border: { color: 'var(--secondary-subtle-hover)' },
            borderRadius: '16px',
          },
        },
      },
    },
  },
});
